import addressJson from "../../address-zip-codes.json";

interface Address {
  Code?: string;
  State?: string;
  City?: string;
}

export function extractOptions(data: Record<string, any>[], field: string) {
  const normalizedValues = data
    .map((item) => item[field])
    .filter((value) => typeof value === "string" && value.trim() !== "")
    .map((value) => value.trim());

  const uniqueValues = Array.from(new Set(normalizedValues));
  return uniqueValues.map((value) => ({
    label: value,
    value: value,
  }));
}

export function extractAllOptions(data: Record<string, any>[]) {
  const fields = ["Code", "State", "City"];
  const options: Record<string, { label: string; value: string }[]> = {};
  fields.forEach((field) => {
    options[field] = extractOptions(data, field);
  });
  return {
    stateOptions: options?.State || [],
    cityOptions: options?.City || [],
    postCodeOptions: options?.Code || [],
  };
}

export function filterOptionsByValue(
  data: Record<string, any>[],
  field: string,
  value: string,
  secondField?: string,
  secondValue?: string
) {
  const result = data?.filter((option: any) => {
    if (secondField && secondValue) {
      return option?.[field] === value && option?.[secondField] === secondValue;
    }
    return option?.[field] === value || false;
  });

  const allOptions = extractAllOptions(result);
  return { ...allOptions, filtered: result };
}

export const addressData = addressJson as Address[];
export const stateOptions = extractOptions(addressData, "State");
export const cityOptions = extractOptions(addressData, "City");
export const codeOptions = extractOptions(addressData, "Code");
